/** Trajetórias (19/10): oportunidade automática da fila (item 4) e a caixa pessoal de quem foi desligado (item 2), nos três idiomas. */
const pt = {
  traj: {
    caixa: {
      selo: 'bloqueada',
      seloEncerrada: 'encerrada',
      bloqueada: 'Caixa bloqueada: a pessoa dona foi desligada em {{data}}. Ninguém lê até você transferir a outra pessoa ou encerrar.',
      encerrada: 'Caixa encerrada depois do desligamento: fica guardada com o histórico, sem leitura.',
      novoDono: 'Transferir para',
      transferir: 'Transferir',
      encerrar: 'Encerrar',
      transferida: 'Caixa transferida',
      encerradaOk: 'Caixa encerrada',
      encerrarTitulo: 'Encerrar esta caixa?',
      encerrarTexto: 'A caixa fica guardada, com o histórico e a auditoria, mas ninguém mais a lê. As delegações saem.',
    },
    oportunidade: {
      titulo: 'Oportunidade automática',
      usar: 'Abrir oportunidade para lead novo',
      ajuda: 'O contato novo que chega por esta fila ganha uma oportunidade no Pipeline na primeira mensagem. Não abre quando a conversa está com a IA: a IA ou a pessoa decide na transferência. Não vale para e-mail: e-mail de quem não tem cadastro não cria contato, e o contato cadastrado pela conversa não ganha oportunidade automática.',
      funil: 'Funil',
      funilPadrao: 'Funil padrão',
      semPipeline: 'Instale o Pipeline para abrir oportunidades automáticas.',
    },
  },
};

type Dic = typeof pt;

const en: Dic = {
  traj: {
    caixa: {
      selo: 'blocked',
      seloEncerrada: 'closed',
      bloqueada: 'Blocked mailbox: its owner was dismissed on {{data}}. Nobody reads it until you transfer it to someone else or close it.',
      encerrada: 'Mailbox closed after the dismissal: kept with its history, with no reading.',
      novoDono: 'Transfer to',
      transferir: 'Transfer',
      encerrar: 'Close',
      transferida: 'Mailbox transferred',
      encerradaOk: 'Mailbox closed',
      encerrarTitulo: 'Close this mailbox?',
      encerrarTexto: 'The mailbox is kept, with its history and audit trail, but nobody reads it anymore. Delegations are removed.',
    },
    oportunidade: {
      titulo: 'Automatic opportunity',
      usar: 'Open an opportunity for new leads',
      ajuda: 'A new contact arriving through this queue gets a Pipeline opportunity on the first message. It is not opened while the conversation is with the AI: the AI or the person decides on handover. It does not apply to e-mail: e-mail from someone not registered does not create a contact, and a contact registered from the conversation gets no automatic opportunity.',
      funil: 'Pipeline',
      funilPadrao: 'Default pipeline',
      semPipeline: 'Install Pipeline to open automatic opportunities.',
    },
  },
};

const es: Dic = {
  traj: {
    caixa: {
      selo: 'bloqueado',
      seloEncerrada: 'cerrado',
      bloqueada: 'Buzón bloqueado: la persona dueña fue desvinculada el {{data}}. Nadie lo lee hasta que lo transfieras a otra persona o lo cierres.',
      encerrada: 'Buzón cerrado después de la desvinculación: queda guardado con el historial, sin lectura.',
      novoDono: 'Transferir a',
      transferir: 'Transferir',
      encerrar: 'Cerrar',
      transferida: 'Buzón transferido',
      encerradaOk: 'Buzón cerrado',
      encerrarTitulo: '¿Cerrar este buzón?',
      encerrarTexto: 'El buzón queda guardado, con el historial y la auditoría, pero nadie más lo lee. Las delegaciones se quitan.',
    },
    oportunidade: {
      titulo: 'Oportunidad automática',
      usar: 'Abrir oportunidad para lead nuevo',
      ajuda: 'El contacto nuevo que llega por esta fila recibe una oportunidad en el Pipeline en el primer mensaje. No se abre cuando la conversación está con la IA: la IA o la persona decide en la transferencia. No vale para el correo: el correo de quien no está registrado no crea contacto, y el contacto registrado desde la conversación no recibe oportunidad automática.',
      funil: 'Embudo',
      funilPadrao: 'Embudo predeterminado',
      semPipeline: 'Instala el Pipeline para abrir oportunidades automáticas.',
    },
  },
};

export const traj = { pt, en, es };
